import React from "react"
import { Card, CardContent, Typography } from '@mui/joy';


const MetricCard = ({ label, value }) => (
    <Card className="mtska-metric-card">
        <CardContent>
            <Typography level="body-sm" className="mtska-metric-label">{label}</Typography>
            <Typography level="h4" className="mtska-metric-value">{value}</Typography>
        </CardContent>
    </Card>
);

export default MetricCard;